module.exports = __webpack_public_path__ + "static/img/hxhq.936469f4.png";